import { z } from "zod";
import { facilityTypeSchema } from "./clinic.ts";

// A branch the current user can switch to (a clinic in the same group where
// the user holds an active membership).
export const branchSummarySchema = z.object({
	clinic_id: z.string().uuid(),
	slug: z.string(),
	name: z.object({ ar: z.string(), en: z.string().optional() }),
	facility_type: facilityTypeSchema,
	role: z.string(),
	is_current: z.boolean(),
});
export type BranchSummary = z.infer<typeof branchSummarySchema>;

export const switchBranchInputSchema = z.object({
	clinic_id: z.string().uuid(),
});
export type SwitchBranchInput = z.infer<typeof switchBranchInputSchema>;

// Consolidated cross-branch report (one row per branch + group totals).
export const branchReportRowSchema = z.object({
	clinic_id: z.string().uuid(),
	name: z.object({ ar: z.string(), en: z.string().optional() }),
	revenue_collected: z.number(),
	outstanding: z.number(),
	patients: z.number(),
	upcoming_appointments: z.number(),
});
export type BranchReportRow = z.infer<typeof branchReportRowSchema>;

export const branchesReportSchema = z.object({
	branches: z.array(branchReportRowSchema),
	totals: z.object({
		revenue_collected: z.number(),
		outstanding: z.number(),
		patients: z.number(),
		upcoming_appointments: z.number(),
	}),
	currency: z.string(),
});
export type BranchesReport = z.infer<typeof branchesReportSchema>;
